import React from 'react';
import { WebsiteDesignProps } from './types';
import { Fingerprint, PlayCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";

const SoftNeumorphism: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Cloud 9 Institute";

    return (
        <div className="bg-[#e0e5ec] min-h-screen font-sans text-[#4a4a4a] selection:bg-[#a3b1c6] selection:text-white">
            <nav className="p-8 flex justify-between items-center">
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-[#e0e5ec] shadow-[9px_9px_16px_rgb(163,177,198,0.6),-9px_-9px_16px_rgba(255,255,255,0.5)] flex items-center justify-center text-blue-500">
                        <Fingerprint />
                    </div>
                    <span className="text-xl font-bold tracking-wide text-slate-600">{schoolName}</span>
                </div>
                <div className="hidden md:flex gap-4">
                    {['Login', 'Support'].map(item => (
                        <Button key={item} className="bg-[#e0e5ec] text-[#4a4a4a] shadow-[6px_6px_12px_rgb(163,177,198,0.6),-6px_-6px_12px_rgba(255,255,255,0.5)] hover:shadow-[inset_6px_6px_12px_rgb(163,177,198,0.6),inset_-6px_-6px_12px_rgba(255,255,255,0.5)] rounded-2xl border border-white/20 px-8 font-semibold transition-all">
                            {item}
                        </Button>
                    ))}
                </div>
            </nav>

            <main className="container mx-auto px-6 py-16 text-center">
                 <div className="inline-block p-10 rounded-[3rem] bg-[#e0e5ec] shadow-[20px_20px_60px_#bebebe,-20px_-20px_60px_#ffffff] mb-16">
                     <h1 className="text-4xl md:text-6xl font-bold text-slate-700 mb-6">
                         Soft. Smooth. Intelligent.
                     </h1>
                     <p className="text-lg text-slate-500 max-w-2xl mx-auto mb-10 leading-relaxed">
                         Education that feels intuitive. We blend technology with human touch to create a seamless learning experience designed for comfort and retention.
                     </p>
                     
                     <div className="flex justify-center gap-8">
                         <button className="w-16 h-16 rounded-full bg-[#e0e5ec] shadow-[9px_9px_16px_rgb(163,177,198,0.6),-9px_-9px_16px_rgba(255,255,255,0.5)] active:shadow-[inset_9px_9px_16px_rgb(163,177,198,0.6),inset_-9px_-9px_16px_rgba(255,255,255,0.5)] flex items-center justify-center text-blue-500 transition-all">
                             <PlayCircle size={32} />
                         </button>
                         <Button className="h-16 rounded-full px-12 bg-blue-500 text-white shadow-[6px_6px_12px_rgba(0,0,0,0.2),-6px_-6px_12px_rgba(255,255,255,0.2)] hover:bg-blue-600 transition-all font-bold tracking-wide">
                             Start Journey
                         </Button>
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
                     {[1,2,3].map((i) => (
                         <div key={i} className="rounded-3xl bg-[#e0e5ec] p-8 shadow-[inset_9px_9px_16px_rgb(163,177,198,0.6),inset_-9px_-9px_16px_rgba(255,255,255,0.5)] flex flex-col items-center">
                             <div className="w-20 h-20 rounded-full mb-6 bg-cover bg-center shadow-[9px_9px_16px_rgb(163,177,198,0.6),-9px_-9px_16px_rgba(255,255,255,0.5)] border-4 border-[#e0e5ec]" style={{backgroundImage: `url('https://images.unsplash.com/photo-${i===1?'1535713875002-d1d0cf377fde':i===2?'1580894734050-66c3d411869d':'1573496359142-b8d87734a5a2'}?q=80&w=200&auto=format&fit=crop')`}}></div>
                             <h3 className="font-bold text-slate-700 mb-2">Student Focus</h3>
                             <p className="text-sm text-slate-500">Centering the experience around the learner's needs.</p>
                         </div>
                     ))}
                 </div>
            </main>
        </div>
    );
};

export default SoftNeumorphism;
